export const dataList=[
{
    title:"Spam",
    detail:"The SMS Spam Collection is a set of SMS tagged messages that have been collected for SMS Spam research.",
    category:"Classification",
    target:1,
    requiredName:"spam"
},
{
    title:"EMNIST",
    detail:"The EMNIST dataset is a set of handwritten character digits derived from the NIST Special Database 19",
    category:"Classification",
    target:2,
    requiredName:"EMNIST"
},
{
    title:"California Housing Price",
    detail:"The data contains information from the 1990 California census, pertains to the houses found in a given California district on the 1990 census data.",
    category:"Regression",
    target:3,
    requiredName:"ca-housing-prices"
},
{
    title:"Machine Translation",
    detail:"Neural machine translation dataset for translating from Korean to English.",
    category:"Generation",
    target:4,
    requiredName:"MT"
},
{
    title:"Q&A Korean",
    detail:"A collection of datasets containing questions and their answers for use in Natural Language Processing tasks like question answering.",
    category:"Generation",
    target:5,
    requiredName:"ko_qna"
},
{
    title:"Hate Speech",
    detail:"Dataset of hate speech annotated on Internet forum posts in English at sentence-level.",
    category:"Classification",
    target:6,
    requiredName:"hate_classification"
},
{
    title:"Boston Housing",
    detail:"The Boston Housing Dataset is a derived from information collected by the U.S. Census Service concerning housing in the area of Boston MA.",
    category:"Regression",
    target:7,
    requiredName:"boston"
},
{
    title:"Dog Classification",
    detail:"This dataset has been built using images and annotation from ImageNet for the task of fine-grained image categorization.",
    category:"Generation",
    target:8,
    requiredName:"dog_image"
},
{
    title:"Shakespeare",
    detail:"A dataset built from The Complete Works of William Shakespeare",
    category:"Classification",
    target:9,
    requiredName:"shakespeare"
},
{
    title:"Celeb",
    detail:"Celeb is a large-scale face attributes dataset with more than 200K celebrity images, each with 40 attribute annotations.",
    category:"Generation",
    target:10,
    requiredName:"celeb"
},
{
    title:"Smilestyle",
    detail:"A data that converts style to 17 different styles for the same multiton conversation data. The description of each style is a description.",
    category:"Generation",
    target:11,
    requiredName:"smilestyle"
},
{
    title:"Speech Command",
    detail:"An audio dataset of spoken words designed to help train and evaluate keyword spotting systems.",
    category:"Classification",
    target:12,
    requiredName:"speech_command"
},
{
    title:"california",
    detail:"The california housing price dataset",
    category:"Regression",
    target:13,
    requiredName:"california"
},
{
    title:"Tweet Sentiment",
    detail:"Extract support phrases for sentiment labels.",
    category:"Generation",
    target:14,
    requiredName:"tweet_sentiment"
},
// {
//     title:"Reddit",
//     detail:"preprocess comments posted on the social network on December 2017",
//     category:"",
//     target:0
// },
// {
//     title:"Sentiment140",
//     detail:"automatically generated sentiment analysis dataset that annotates tweets based on the emoticons presentin them",
//     category:"",
//     target:0
// },
// {
//     title:"CelebA",
//     detail:"partitions the Large-scale CelebFaces Attributes Dataset 3 by the celebrity on the picture",
//     category:"",
//     target:0
// },
// {
//     title:"Synthetic Dataset",
//     detail:"synthetic dataset presented in to make it more challenging for current meta-learning methods",
//     category:"",
//     target:0
// },
// {
//     title:"Reddit",
//     detail:"preprocess comments posted on the social network on December 2017",
//     category:"",
//     target:0
// },
// {
//     title:"Shakespeare",
//     detail:"a dataset built from The Complete Works of William Shakespeare",
//     category:"",
//     target:0
// },
// {
//     title:"Sentiment140",
//     detail:"automatically generated sentiment analysis dataset that annotates tweets based on the emoticons presentin them",
//     category:"",
//     target:0
// },
// {
//     title:"CelebA",
//     detail:"partitions the Large-scale CelebFaces Attributes Dataset 3 by the celebrity on the picture",
//     category:"",
//     target:0
// },
// {
//     title:"Synthetic Dataset",
//     detail:"synthetic dataset presented in to make it more challenging for current meta-learning methods",
//     category:"",
//     target:0
// },
// {
//     title:"Reddit",
//     detail:"preprocess comments posted on the social network on December 2017",
//     category:"",
//     target:0
// },
]